import { render } from "./BtngroupSingle.vue?vue&type=template&id=3da06082&scoped=true"
import script from "./BtngroupSingle.vue?vue&type=script&lang=js"
export * from "./BtngroupSingle.vue?vue&type=script&lang=js"

import "./BtngroupSingle.vue?vue&type=style&index=0&id=3da06082&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da06082"]])

export default __exports__